'use strict';

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var React = require('react');
var Reflux = require('reflux');

/* Stores */
var DatasourceStore = require('stores/datasource');
var LanguageStore = require('stores/language');

/* Components */
var TitledGroup = require('components/ui/titled-group');
var TextField = require('components/ui/text-field');
var ContentItem = require('./content-item');
var SmallButton = require('components/ui/small-button');

var DatasourceContentList = React.createClass({
  displayName: 'DatasourceContentList',

  mixins: [Reflux.listenTo(DatasourceStore, 'onDatasourceStoreChange')],

  getInitialState: function getInitialState() {
    return {
      items: [],
      selectedItems: []
    };
  },

  onDatasourceStoreChange: function onDatasourceStoreChange() {
    this.setState({ items: DatasourceStore.items });
  },

  render: function render() {
    var component = this;

    var state = component.state;
    var _onSearchQueryChange = component._onSearchQueryChange;
    var _onSelectAll = component._onSelectAll;
    var _onDeleteClick = component._onDeleteClick;
    var _onCopyClick = component._onCopyClick;
    var _onCreateClick = component._onCreateClick;
    var _onCreateBundle = component._onCreateBundle;
    var _onChangeForSale = component._onChangeForSale;
    var _component$state = component.state;
    var items = _component$state.items;
    var selectedItems = _component$state.selectedItems;

    var contentNodes = items.map(function (item) {
      var selected = selectedItems.includes(item.id);
      return React.createElement(ContentItem, {
        key: item.id,
        item: item,
        selected: selected,
        onClick: component._onItemClick,
        onEditClick: component._onEditClick });
    });

    var allItemCount = DatasourceStore.items.length;
    var itemCount = items.length;
    var selectedItemCount = selectedItems.length;

    if (!itemCount) {
      var noContentText = LanguageStore.translate('datasource_details_items_missing_title');
      var noContentButtonText = LanguageStore.translate('datasource_details_items_create');

      contentNodes = React.createElement(
        'div',
        { className: 'item-component no-item-component' },
        noContentText,
        React.createElement(SmallButton, {
          value: noContentButtonText,
          className: 'create',
          onClick: _onCreateClick })
      );
    }

    /* Translations */
    var selectAllButtonText = itemCount === selectedItemCount ? 'deselect_all' : 'select_all';
    var deleteButtonText = 'delete';
    var copyButtonText = 'copy';
    var createButtonText = 'create';
    var forSaleButtonText = 'for_sale';
    var notForSaleButtonText = 'not_for_sale';

    var searchNode = null;

    if (allItemCount) {
      searchNode = React.createElement(
        'div',
        { className: 'search-wrapper' },
        React.createElement(TextField, { translationKey: 'search', disabled: !allItemCount, onChange: _onSearchQueryChange })
      );
    }

    var buttonsNode = null;

    if (allItemCount) {
      buttonsNode = React.createElement(
        'div',
        { className: 'buttons' },
        React.createElement(SmallButton, { translationKey: selectAllButtonText, disabled: !itemCount, onClick: _onSelectAll }),
        React.createElement(SmallButton, { translationKey: createButtonText, className: 'create', onClick: _onCreateClick }),
        React.createElement(SmallButton, { translationKey: copyButtonText, disabled: !selectedItemCount, className: 'copy', onClick: _onCopyClick }),
        React.createElement(SmallButton, { translationKey: deleteButtonText, disabled: !selectedItemCount, className: 'delete', onClick: _onDeleteClick }),
        React.createElement(SmallButton, { translationKey: selectedItemCount === 1 && DatasourceStore.items.find(function (i) {
            return i.id === selectedItems[0];
          }).forSale ? forSaleButtonText : notForSaleButtonText, disabled: selectedItemCount !== 1, className: 'for-sale', onClick: _onChangeForSale })
      );
    }

    return React.createElement(
      TitledGroup,
      { className: 'list-component datasource-content-list-component' },
      searchNode,
      buttonsNode,
      React.createElement(
        'div',
        { className: 'content' },
        contentNodes
      )
    );
  },

  _onSearchQueryChange: function _onSearchQueryChange(evt) {
    var _this = this;

    var component = this;
    var query = evt.target.value;
    var items = DatasourceStore.items;

    // Reset selectedItems state
    component.setState({ selectedItems: [] });

    if (query.length) {
      (function () {
        // Make query lowercase, split into words and filter out empty ones
        var queryWords = query.toLowerCase().split(' ').filter(function (word) {
          return !!word;
        });

        // Filter items by query words. Every word has to find a match (exclusive)
        items = items.filter(function (item) {
          return queryWords.every(function (word) {
            return _this._matches(item, word);
          });
        });
      })();
    }

    component.setState({ items: items });
  },

  _matches: function _matches(obj, target) {
    var _this2 = this;

    target = target.toLowerCase();
    var type = Object.prototype.toString.call(obj).match(/\s([a-z]+)\]$/i)[1].toLowerCase();

    switch (type) {
      case 'number':
      case 'string':
        return obj.toString().toLowerCase().indexOf(target.toLowerCase()) !== -1;
      case 'boolean':
        return target === 'true' && obj || target === 'false' && !obj;
      case 'array':
        return obj.some(function (item) {
          return _this2._matches(item, target);
        });
      case 'object':
        return Object.keys(obj).some(function (key) {
          return _this2._matches(obj[key], target);
        });
      default:
        return false;
    }
  },

  _onItemClick: function _onItemClick(itemId) {
    var component = this;
    var selectedItems = component.state.selectedItems;

    if (selectedItems.includes(itemId)) {
      selectedItems.splice(selectedItems.indexOf(itemId), 1);
    } else {
      selectedItems.push(itemId);
    }

    component.setState({ selectedItems: selectedItems });
  },

  _onEditClick: function _onEditClick(item) {
    var props = this.props;

    if (props.onEditItem) {
      props.onEditItem(item);
    }
  },

  _onDeleteClick: function _onDeleteClick() {
    if (confirm(LanguageStore.translate('datasource_details_items_delete_confirmation'))) {
      var component = this;
      var props = component.props;

      if (props.onDeleteItems) {
        props.onDeleteItems(component.state.selectedItems);

        var selectedItems = [];

        component.setState({ selectedItems: selectedItems });
      }
    }
  },

  _onCopyClick: function _onCopyClick() {
    var component = this;
    var props = component.props;

    if (props.onCopyItems) {
      props.onCopyItems(component.state.selectedItems);
    }
  },

  _onCreateClick: function _onCreateClick() {
    var component = this;
    var props = component.props;

    if (props.onCreateItem) {
      props.onCreateItem();
    }
  },

  _onSelectAll: function _onSelectAll() {
    var component = this;
    var state = component.state;
    var selectedItems = state.items.map(function (item) {
      return item.id;
    });
    if (state.selectedItems.length === selectedItems.length) {
      selectedItems = [];
    }
    component.setState({ selectedItems: selectedItems });
  },

  _onChangeForSale: function _onChangeForSale() {
    var _state$selectedItems = _slicedToArray(this.state.selectedItems, 1);

    var itemId = _state$selectedItems[0];

    var item = DatasourceStore.items.find(function (item) {
      return item.id === itemId;
    });

    this.props.onChangeForSale(itemId, !item.forSale);
  }
});

module.exports = DatasourceContentList;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/datasource/content-list.js
 **/